"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectTeamsManifestArguments = exports.SelectTeamsManifestOptions = void 0;
exports.SelectTeamsManifestOptions = [
    {
        name: "teams-manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specify the path for Teams app manifest template. It can be either absolute path or relative path to the project root folder, with default at './appPackage/manifest.json'",
        required: true,
        default: "./appPackage/manifest.json",
    },
];
exports.SelectTeamsManifestArguments = [];
//# sourceMappingURL=SelectTeamsManifestOptions.js.map